module.exports = __webpack_public_path__ + "img/table-medical-climbing.9dcfc845.svg";